"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcContractProtocolHeader = class UcContractProtocolHeader extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    protocol;
    onProtocol(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("protocol");
    }
    messages;
    ux;
    dataMembers = ['messages', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    handoverTypes: {
                        moving_in: this.$fn.pgettext("HandoverType", "Moving-in protocol"),
                        moving_out: this.$fn.pgettext("HandoverType", "Moving-out protocol"),
                    },
                    newTransaction: this.$fn.pgettext("ContractProtocol", "New protocol"),
                    editTransaction: this.$fn.pgettext("ContractProtocol", "Edit protocol"),
                },
                ux: null,
            },
        };
    }
    get isNew() {
        if (this.loaded) {
            return this.protocol.isNew;
        }
        return null;
    }
    get resourceTitle() {
        if (this.loaded) {
            return this.messages.handoverTypes[this.protocol.handover_type];
        }
        return null;
    }
    get resourceKey() {
        if (this.loaded) {
            return this.isNew ? this.messages.newTransaction : this.messages.editTransaction;
        }
        return null;
    }
    async act_1040167445267876_emit_8564_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_1040167445267876_clickPreventStop(event, scope) {
        return await this.actions.evh_1040167445267876_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_4942415580156499_closeComponent_8568_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_4942415580156499_crud_8566_getActionArgs($event) {
        return {
            objectType: "contract_protocol",
            op: "upsert",
            data: { ...this.protocol, protocol_status: 'completed' },
        };
    }
    async act_4942415580156499_crud_8566_getConfirm($event) {
        return {
            header: "Jegyőkönyv véglegesítése",
            message: "A jegyzőkönyv véglegesítés után már nem módosítható.",
            btnOk: "Véglegesítés",
            severity: "warning",
        };
    }
    async evh_4942415580156499_clickPreventStop(event, scope) {
        return await this.actions.evh_4942415580156499_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_49312645155713_emit_8572_getActionArgs($event) {
        return {
            event: "close",
        };
    }
    async act_49312645155713_crud_8570_getActionArgs($event) {
        return {
            objectType: "contract_protocol",
            op: "upsert",
            data: { ...this.protocol, protocol_status: 'cancelled' },
        };
    }
    async act_49312645155713_crud_8570_getConfirm($event) {
        return {
            header: "Jegyőkönyv érvénytelenítése",
            message: "A jegyzőkönyv érvénytelenítés után már nem módosítható.",
            btnOk: "Érvénytelenítés",
            severity: "warning",
        };
    }
    async evh_49312645155713_clickPreventStop(event, scope) {
        return await this.actions.evh_49312645155713_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_237785848579802_emit_8576_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_237785848579802_request_8574_getActionArgs($event) {
        return {
            url: this.protocol.links.self,
            method: "patch",
            data: {
                etag: this.protocol.etag,
                locked: true,
            },
        };
    }
    async evh_237785848579802_clickPreventStop(event, scope) {
        return await this.actions.evh_237785848579802_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_6883979544763359_emit_8580_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_6883979544763359_request_8578_getActionArgs($event) {
        return {
            url: this.protocol.links.self,
            method: "patch",
            data: {
                etag: this.protocol.etag,
                locked: false,
            },
        };
    }
    async evh_6883979544763359_clickPreventStop(event, scope) {
        return await this.actions.evh_6883979544763359_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3329008617875226_emit_8582_getActionArgs($event) {
        return {
            event: "deleted",
        };
    }
    async evh_3329008617875226_success(event, scope) {
        return await this.actions.evh_3329008617875226_success.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_1040167445267876_emit_8564 = new core_1.actions.EmitAction({
            actionArgs: this.act_1040167445267876_emit_8564_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_1040167445267876_clickPreventStop_8563 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_emit_8564,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_1040167445267876_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_clickPreventStop_8563],
        });
        const act_4942415580156499_closeComponent_8568 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_4942415580156499_closeComponent_8568_getActionArgs,
            events: [],
        });
        const evh_4942415580156499_success_8567 = new core_1.actions.EventHandlerImpl({
            action: act_4942415580156499_closeComponent_8568,
            event: "success",
            displayName: "closeComponent",
        });
        const act_4942415580156499_crud_8566 = new core_1.actions.CRUDAction({
            actionArgs: this.act_4942415580156499_crud_8566_getActionArgs,
            confirm: this.act_4942415580156499_crud_8566_getConfirm,
            displayName: "complete",
            events: [evh_4942415580156499_success_8567],
        });
        const evh_4942415580156499_clickPreventStop_8565 = new core_1.actions.EventHandlerImpl({
            action: act_4942415580156499_crud_8566,
            event: "click.prevent.stop",
            displayName: "complete",
        });
        const evh_4942415580156499_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4942415580156499_clickPreventStop_8565],
        });
        const act_49312645155713_emit_8572 = new core_1.actions.EmitAction({
            actionArgs: this.act_49312645155713_emit_8572_getActionArgs,
            events: [],
        });
        const evh_49312645155713_success_8571 = new core_1.actions.EventHandlerImpl({
            action: act_49312645155713_emit_8572,
            event: "success",
            displayName: "emit",
        });
        const act_49312645155713_crud_8570 = new core_1.actions.CRUDAction({
            actionArgs: this.act_49312645155713_crud_8570_getActionArgs,
            confirm: this.act_49312645155713_crud_8570_getConfirm,
            displayName: "complete",
            events: [evh_49312645155713_success_8571],
        });
        const evh_49312645155713_clickPreventStop_8569 = new core_1.actions.EventHandlerImpl({
            action: act_49312645155713_crud_8570,
            event: "click.prevent.stop",
            displayName: "complete",
        });
        const evh_49312645155713_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_49312645155713_clickPreventStop_8569],
        });
        const act_237785848579802_emit_8576 = new core_1.actions.EmitAction({
            actionArgs: this.act_237785848579802_emit_8576_getActionArgs,
            events: [],
        });
        const evh_237785848579802_success_8575 = new core_1.actions.EventHandlerImpl({
            action: act_237785848579802_emit_8576,
            event: "success",
            displayName: "emit",
        });
        const act_237785848579802_request_8574 = new core_1.actions.RequestAction({
            actionArgs: this.act_237785848579802_request_8574_getActionArgs,
            displayName: "lock",
            events: [evh_237785848579802_success_8575],
        });
        const evh_237785848579802_clickPreventStop_8573 = new core_1.actions.EventHandlerImpl({
            action: act_237785848579802_request_8574,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_237785848579802_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_237785848579802_clickPreventStop_8573],
        });
        const act_6883979544763359_emit_8580 = new core_1.actions.EmitAction({
            actionArgs: this.act_6883979544763359_emit_8580_getActionArgs,
            events: [],
        });
        const evh_6883979544763359_success_8579 = new core_1.actions.EventHandlerImpl({
            action: act_6883979544763359_emit_8580,
            event: "success",
            displayName: "emit",
        });
        const act_6883979544763359_request_8578 = new core_1.actions.RequestAction({
            actionArgs: this.act_6883979544763359_request_8578_getActionArgs,
            displayName: "lock",
            events: [evh_6883979544763359_success_8579],
        });
        const evh_6883979544763359_clickPreventStop_8577 = new core_1.actions.EventHandlerImpl({
            action: act_6883979544763359_request_8578,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_6883979544763359_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6883979544763359_clickPreventStop_8577],
        });
        const act_3329008617875226_emit_8582 = new core_1.actions.EmitAction({
            actionArgs: this.act_3329008617875226_emit_8582_getActionArgs,
            events: [],
        });
        const evh_3329008617875226_success_8581 = new core_1.actions.EventHandlerImpl({
            action: act_3329008617875226_emit_8582,
            event: "success",
            displayName: "emit",
        });
        const evh_3329008617875226_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3329008617875226_success_8581],
        });
        return {
            act_1040167445267876_emit_8564,
            evh_1040167445267876_clickPreventStop_8563,
            evh_1040167445267876_clickPreventStop,
            act_4942415580156499_closeComponent_8568,
            evh_4942415580156499_success_8567,
            act_4942415580156499_crud_8566,
            evh_4942415580156499_clickPreventStop_8565,
            evh_4942415580156499_clickPreventStop,
            act_49312645155713_emit_8572,
            evh_49312645155713_success_8571,
            act_49312645155713_crud_8570,
            evh_49312645155713_clickPreventStop_8569,
            evh_49312645155713_clickPreventStop,
            act_237785848579802_emit_8576,
            evh_237785848579802_success_8575,
            act_237785848579802_request_8574,
            evh_237785848579802_clickPreventStop_8573,
            evh_237785848579802_clickPreventStop,
            act_6883979544763359_emit_8580,
            evh_6883979544763359_success_8579,
            act_6883979544763359_request_8578,
            evh_6883979544763359_clickPreventStop_8577,
            evh_6883979544763359_clickPreventStop,
            act_3329008617875226_emit_8582,
            evh_3329008617875226_success_8581,
            evh_3329008617875226_success,
            reload: act_1040167445267876_emit_8564,
            complete: act_49312645155713_crud_8570,
            lock: act_6883979544763359_request_8578,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcContractProtocolHeader.prototype, "protocol", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('protocol'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractProtocolHeader.prototype, "onProtocol", null);
UcContractProtocolHeader = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcContractProtocolHeader);
exports.default = UcContractProtocolHeader;
vue_property_decorator_1.Vue.component("UcContractProtocolHeader", UcContractProtocolHeader);
